import axios from 'axios';
//var axios = require('axios');
var FormData = require('form-data');
var api_url = 'https://bp-backend.arodek.com/api.php';
var customer_api_url = 'https://bp-backend.arodek.com/customer/api.php';
var vendor_api_url = 'https://bp-backend.arodek.com/vendor/api.php';
var material_api_url = 'https://bp-backend.arodek.com/material/api.php';
var material_upload_url = 'https://cusproapi.ifbsupport.com/material/file_upload.php';
var material_upload_url2= 'https://bp-backend.arodek.com/material/api.php';
var upload_url = "https://bp-backend.arodek.com/file_upload.php";
var customer_upload_url = "https://bp-backend.arodek.com/customer/file_upload.php";
var vendor_upload_url = "https://bp-backend.arodek.com/vendor/file_upload.php";
var anmol_api_url = "https://anmolmdm-backend.arodek.com/api/app/user";

export function authLogin(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function getDocumentNo(data) {
    return axios.post(material_upload_url2,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function saveMaterialRows(data) {
    return axios.post(material_upload_url2,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function getDocNumList(data) {
    return axios.post(material_upload_url2,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function getMaterialListFromDoc(data) {
    return axios.post(material_upload_url2,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGetApprovedBP(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGetApprovedCustomer(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authMaterialCreation(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authCustomer(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authVendorCreation(data) {
    return axios.post(vendor_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authMaterialType(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authMaterialGroupPack(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authValuationClassMapping(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authMaterialCategory(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authMaterialMapping(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authPCMapping(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authBaseUnit(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authMaterialConsolidation(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authOverheadGroup(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authDistributionChannel(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authPricingProcedure(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authRegionSalesDistrict(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

 
  

  export function authCustomerStatisticGroup(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
 
 export function authIncoterm2(data) {
  return axios.post(customer_api_url,data,{
    headers: {
        'Accept' : 'application/json',
        'Content-Type': 'application/json'
    }});
}
 export function authIncoterm(data) {
  return axios.post(customer_api_url,data,{
    headers: {
        'Accept' : 'application/json',
        'Content-Type': 'application/json'
    }});
}
  export function authCheckCurrentPassword(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authSavePassword(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authApprovalStatus(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  
  export function authLocation(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authDivision(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authRegion(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authTermsofPayment(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authSalesDistrict(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authSalesOffice(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authSalesGroup(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authShippingCondition(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authPartnerFunction(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authReconAccount(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authAccountGroup(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authSalesOrganization(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authCompanyCode(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGoodsTAX(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authTotalCustomer(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authTotalApprovedCustomer(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authTotalRejectedCustomer(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authTotalPendingCustomer(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authSalesOfficeGroupMapping(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authPostalCodeMaster(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGeoMapping(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authIndustryCode(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authAccountAssignmentGroup(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authCustomerCreation(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authBPCreation(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authBP(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authApprovarCreation(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authGetFirstApprovarList(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGetFinalApprovarList(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGetCustomer(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authGetBP(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGetVendor(data) {
    return axios.post(vendor_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGetMaterial(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGetCustomerDetails(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGetMaterialDetails(data) {
    return axios.post(material_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authSaveApprovalStatus(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authSaveApprovalStatusFromExporter(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }


  export function authUserRegistration(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGSTNIntegration(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authGetUser(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function deleteApprover(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function settingGSTNvalidation(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function getGSTValidationStatus(data) {
    return axios.post(customer_api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function getGSTValidation(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authCustomerSearch(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }
  export function authApproveSearch(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authUpdateSAPNo(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function authUpdateCustomer(data) {
    return axios.post(api_url,data,{
      headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }});
  }

  export function fileUpload(file) {
    var data = new FormData();
    data.append("pdf_file", file);
    //console.log(data.get("pdf_file"));
    return axios.post(customer_upload_url, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/ form-data",
      },
    });
  }

  export function fileBPUpload(file) {
    var data = new FormData();
    data.append("pdf_file", file);
    console.log(data.get("pdf_file"));
    return axios.post(upload_url, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/ form-data",
      },
    });
  }
  export function fileVendorUpload(file) {
    var data = new FormData();
    data.append("pdf_file", file);
   
    return axios.post(vendor_upload_url, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/ form-data",
      },
    });
  }